import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
const columns = [
    { key: 'id', label: 'ID', width: 88, minWidth: 72, resizable: true },
    { key: 'name', label: 'Name', minWidth: 240, resizable: true },
    { key: 'description', label: 'Description', minWidth: 280, resizable: true },
    { key: 'actions', label: 'Actions', align: 'center', width: 96, minWidth: 88, required: true },
];
export function renderTransmissionGroupsTable() {
    return renderKoDataTable({
        title: 'Transmission Groups',
        titleIcon: 'stack',
        caption: 'Transmission groups',
        columns,
        className: 'transmission-groups-table',
        children: renderBody(),
    });
}
function renderBody() {
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: groups' },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: '$data.name || $data.label || ""', titleBinding: '$data.name || $data.label || ""' })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: '$data.description || ""', clampLines: 2, titleBinding: '$data.description || ""' })}
                    ${LpTable.Cell({ column: columns[3], children: LpButton({ ariaLabel: 'Edit', prefixIcon: 'pencil-simple', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickEdit' } }) })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'groups().length === 0', title: 'No transmission groups found', description: 'Create a group to organize transmissions.', icon: 'stack' })}
    `;
}
